import { render, staticRenderFns } from "./Secure.vue?vue&type=template&id=71c0bc46&scoped=true&"
import script from "./Secure.vue?vue&type=script&lang=js&"
export * from "./Secure.vue?vue&type=script&lang=js&"
import style0 from "./Secure.vue?vue&type=style&index=0&id=71c0bc46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c0bc46",
  null
  
)

export default component.exports